import cns from 'classnames';
import { useTranslation } from 'next-i18next';
import { Stack } from '@zep/ui';
import { Currency } from '../../../../types/GlobalTypes';
import { fCurrency } from '../../../../utils';
import { usePlanSpaceDetailContext } from '../plan';
import { PlanSpaceGroup } from '../space/organisms';
import S from './AppliedPlan.module.scss';
export const PaymentPrice = () => {
  const {
    t
  } = useTranslation(['subscription']);
  const {
    nextPaymentPriceInfo,
    spacePlan
  } = usePlanSpaceDetailContext();

  // current plan 가격은 서버가 내려준 금액 그대로 표시한다.
  // 클라 1.1배 재계산, country 기준 "(VAT 포함)" 라벨 모두 금지 (Gate E).
  const localPrice = fCurrency(nextPaymentPriceInfo?.finalPrice ?? spacePlan?.salePrice ?? 0, (nextPaymentPriceInfo?.currency ?? spacePlan?.currency) as Currency, {
    currencyString: t('subscription:currency.won')
  });
  return <PlanSpaceGroup title={t('subscription:payment.summaryCommon.price')} data-sentry-element="PlanSpaceGroup" data-sentry-component="PaymentPrice" data-sentry-source-file="PaymentPrice.tsx">
      <Stack direction={'row'} gap={8} style={{
      alignItems: 'center'
    }} data-sentry-element="Stack" data-sentry-source-file="PaymentPrice.tsx">
        <label className={cns(S.label, S.gray)}>{localPrice}</label>
      </Stack>
    </PlanSpaceGroup>;
};